import React from "react";
import PropTypes from "prop-types";
import {
  Form,
  FormGroup,
  FormFeedback,
  Fade,
  Error,
  Input,
  Select,
  Button,
  Password,
  Modal
} from "../../simple";
import SVG from "../../SVG";
import { validate, validationRules } from "../../../helpers/validate";
import countries from "../../../assets/countries.json";

export default class ActivateForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {
        name: "",
        password: ""
      },
      validation: {
        name: true,
        password: true
      }
    };
    this.handleChangeValidate = this.handleChangeValidate.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChangeValidate(name, value) {
    const { handleChange } = this.props;
    this.setState(({ data, validation }) => ({
      data: { ...data, [name]: value },
      validation: {
        ...validation,
        [name]: validate(value, validationRules[name])
      }
    }));
    handleChange(this.state.data);
  }

  handleChange(name, value) {
    const { handleChange } = this.props;
    this.setState(({ data }) => ({
      data: { ...data, [name]: value }
    }));
    handleChange(this.state.data);
  }

  handleSubmit(evt) {
    const { data } = this.state;
    const {
      data: { id }
    } = this.props;

    evt.preventDefault();
    this.props.handleSubmit({ ...data, id });
  }

  render() {
    const {
      data: { name, password },
      validation
    } = this.state;
    const { data, fieldErrors } = this.props;
    const isSubmitDisabled = !(
      name &&
      password &&
      // validation.name &&
      validation.password
    );

    return (
      <Form onSubmit={this.handleSubmit} className="sign-up-form">
        <h2 className="title">Create your account</h2>
        <SVG.AddUser className="form-icon" />
        <FormGroup>
          <Input
            type="text"
            value={name}
            label="Name"
            name="name"
            placeholder="Name"
            handleChange={this.handleChangeValidate}
            invalid={/* !validation.name || */ !!fieldErrors.name}
            required
            fieldError={fieldErrors.name || "Please, provide a valid name"}
          />
          <Input
            type="email"
            value={data.email}
            label="Email"
            name="email"
            readOnly={!!data.email}
            placeholder="Email"
            invalid={!!fieldErrors.email}
            handleChange={this.handleChangeValidate}
            required
            fieldError={fieldErrors.email || "Please, provide a valid email"}
          />
          <Password
            value={password}
            label="Password"
            name="password"
            placeholder="Password"
            invalid={!validation.password || !!fieldErrors.password}
            handleChange={this.handleChangeValidate}
            required
            fieldError={
              fieldErrors.password ||
              "Please, provide a password, that includes at least 1 letter, 1 capital, 1 special character, 1 number and have at least 8 characters length"
            }
          />
          <Input
            type="text"
            value={data.company}
            label="Company"
            name="company"
            readOnly={!!data.company}
            placeholder="Company"
            handleChange={this.handleChange}
            invalid={!!fieldErrors.company}
            required
            fieldError={fieldErrors.company}
          />
          <Select
            value={countries.find(c => c.label === data.country?.name) || ""}
            label="Country"
            placeholder="Country"
            options={countries}
            name="country"
            isDisabled={!!data.country}
            handleChange={this.handleChange}
            required
          />
          <Fade
            in={typeof fieldErrors !== "object"}
            tag="div"
            className="form-error"
          >
            <Error component={FormFeedback} error={fieldErrors} />
          </Fade>
        </FormGroup>
        <Button type="submit" className="button" disabled={isSubmitDisabled}>
          Continue
          <SVG.Arrow className="icon" />
        </Button>
      </Form>
    );
  }
}

ActivateForm.propTypes = {
  data: PropTypes.shape({
    id: PropTypes.string,
    company: PropTypes.string,
    email: PropTypes.string,
    country: PropTypes.shape({
      name: PropTypes.string
    })
  }),
  fieldErrors: PropTypes.oneOfType([
    PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.arrayOf(PropTypes.string),
        password: PropTypes.arrayOf(PropTypes.string)
      })
    ),
    PropTypes.shape({
      name: PropTypes.arrayOf(PropTypes.string),
      password: PropTypes.arrayOf(PropTypes.string)
    }),
    PropTypes.string
  ]),
  handleChange: PropTypes.func,
  handleSubmit: PropTypes.func.isRequired
};

ActivateForm.defaultProps = {
  data: {},
  fieldErrors: "",
  handleChange: () => null
};

export function ActivateModal(props) {
  const { isOpen, goBackAction, ...formProps } = props;

  return (
    <Modal className="sign-up screen-modal" isOpen={isOpen}>
      <Button className="btn-transparent close-modal" onClick={goBackAction}>
        <SVG.Arrow className="arrow-right-red" width={18} height={13} />
        Back
      </Button>
      <ActivateForm {...formProps} />
    </Modal>
  );
}

ActivateModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  goBackAction: PropTypes.func.isRequired
};
